module.exports = __webpack_public_path__ + "assets/img/desktop.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/desktop.svg
// module id = 1979
// module chunks = 0